<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span
                        *ngIf="options?.isRoleChange; else deletionUser"
                        class="highlight-user"
                    >
                        {{
                            options?.staff?.contactDetails?.firstName +
                                " " +
                                options?.staff?.contactDetails?.lastName
                        }}
                    </span>
                    <ng-template #deletionUser>
                        <span class="highlight-user">
                            {{
                                options?.staff?.firstName +
                                    " " +
                                    options?.staff?.lastName
                            }}
                        </span>
                    </ng-template>
                    <span *ngIf="options?.staff?.isRemoveUserFromProject">
                        {{ "OutstandingItemsBeforeRemoveUserFromProject" | localize }}
                    </span>
                    <span *ngIf="!options?.staff?.isRemoveUserFromProject">
                        {{
                            options?.isRoleChange
                                ? ("OutstandingItemsBeforeChangingTheUserRole"
                                  | localize)
                                : ("OutstandingItemsBeforeDeletingTheUser"
                                  | localize)
                        }}
                    </span>
                </h4>
            </div>
            <div class="modal-body">
                <h4 class="mb-4">{{ "OpenItems" | localize }}</h4>

                <div
                    *ngIf="
                        options?.checkOutput?.notAcceptedAllocationSheetsExist
                    "
                    class="d-flex mb-4"
                >
                    <div class="item-circler-dot"></div>
                    <span>{{ "UnacceptedAllocationSheets" | localize }}</span>
                </div>

                <div
                    *ngIf="options?.checkOutput?.notEnrolledActivitiesExist"
                    class="d-flex"
                >
                    <div class="item-circler-dot"></div>
                    <span>{{ "OpenActivities" | localize }}</span>
                </div>
            </div>

            <div class="footer">
                <div class="left-section">
                    <button
                        (click)="loginAsUser()"
                        class="btn btn-outline-danger font-weight-bold"
                        type="button"
                    >
                        {{ "LoginAsUser" | localize }}
                    </button>
                </div>

                <div class="right-section">
                    <button
                        (click)="close()"
                        class="btn font-weight-bold"
                        type="button"
                    >
                        {{ "Cancel" | localize }}
                    </button>
                    <button
                        (click)="askUserTocloseItems()"
                        class="btn btn-primary font-weight-bold"
                        type="button"
                    >
                        {{ "AskUserToCloseItems" | localize }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
